<template>
<!-- mobile :text="!isXsDevice" :preText="!isXsDevice" -->
  
        <v-row v-if="!isMobile" no-gutters :style="`max-width:${maxWidth}`" align="center">
            <v-col v-if="preText || text" class="text-right">
                <div class="progress-text-circle">
                    <span v-if="preText" class="grey--text font-weight-medium" :style="{'color':theme.footerIconColor + '!important'}">{{ this.preOutput}}</span>
                    <br>
                    <span v-if="text" class="grey--text  text--darken-2 font-weight-bold" :style="{'color':theme.footerIconColor + '!important'}">{{ this.output}}</span>
                </div>
            </v-col>
            <v-col v-if="circle" :cols="(preText || text)?3:12" class="text-right" >
                <v-progress-circular
                    :value="progress"
                    :color="theme.footerIconColor"
                    :width="5"
                    class="progress-circle"
                    ></v-progress-circular>
            </v-col>
        </v-row>
        <v-menu 
            v-else
            bottom
            offset-y
            rounded="b-xl t-0"
            content-class="mt-1 menuShadow"
            outlined
            >
            <template v-slot:activator="{ on, attrs }">

                <v-progress-circular
                    v-if="circle"
                    :value="progress"
                    :color="theme.footerIconColor"
                    :width="5"
                    v-bind="attrs"
                    v-on="on"
                    >
                </v-progress-circular>
            </template>
            <span>
                <v-card
                    class="mx-auto"
                    max-width="275"
                    tile
                >
                    <v-card-text :style="{'background-color': theme.backgroundColor}">
                        <div v-if="preText || text" class="text-left">
                            <span v-if="preText" class="v-list-item__title" :style="{'color': theme.footerIconColor}">{{ this.preOutput}}</span><br><span v-if="text" class="grey--text  text--darken-2 font-weight-bold" :style="{'color':theme.footerIconColor + '!important'}">{{ this.output}}</span>
                        </div>
                    </v-card-text>
                </v-card>
            </span>
        </v-menu>
</template>

<script>

import {countdownBehavior} from './countdownBehavior.js'
import {layoutMixin} from '@/utils/layout-mixin'

export default {
    name:'EspCountdownProgress',
    mixins:[countdownBehavior,layoutMixin],
    props:{
        preText:{
            type:Boolean,
            default:true,
        },
        text:{
            type:Boolean,
            default:true,
        },
        circle:{
            type:Boolean,
            default:true
        },
        startEventDate:{
            type:String
        },
        endEventDate:{
            type:String
        },
        color:{
            type:String,
            default:'red'
        },
        maxWidth:{
            type:String,
            default:'200px'  
        },
        finishCountDownAfterEnd:{
            type:Boolean,
            default:false
        },
        // remaining ms shown frozen (full progress) while the team countdown has not started yet
        frozenRemaining:{
            type:Number,
            default:null
        },
        isMobile:{
            type:Boolean,
            default:false,
        },
        countDownProgresColor: {}
    },
    data() {
        return {
            countDownProgresColorValue: this.countDownProgresColor
        }
    },
    created() {
        this.assignPseudoElementStyle();
    },
    watch:{
        /* Init data on creation and on update */
        startEventDate: {
            handler(val) {
                this.customStartDate=new Date(val);
                this.startCountdownSafety();
            },
            immediate: true
        },
        endEventDate: {
            handler(val) {
                this.customEndDate=new Date(val);
                this.startCountdownSafety();
            },
            immediate: true
        },
        finishCountDownAfterEnd:{
            handler(val) {
                this.stopCountDownAfterEnd=val;
            },
            immediate: true
        },
        frozenRemaining:{
            handler(val) {
                this.frozenRemainingMs=val;
            },
            immediate: true
        }
    },
    computed: {

        output(){
            var res="";
            res+=(this.years>0)?this.years + "y ":"";
            res+=(this.months>0)?this.months + "m ":"";
            res+=(this.days>0)?this.days + "d ":"";
            if(this.years<=0){
                res+=(this.hours>0)?this.hours + "h ":"";
            }
            if(this.months<=0){
                res+=(this.minutes>0)?this.minutes + "m ":"";
            }
            if(this.hours<=0){
                res+=this.seconds + "s "
            }
            return res;
        },
    },
    methods:{
        startCountdownSafety(){
            if(this.customStartDate && this.customEndDate){
                this.startCountdown();
            }
        },
        assignPseudoElementStyle() {
            this.countDownProgresColorValue = this.theme.footerIconColor;
            document.documentElement.style.setProperty('--count-down-progress', this.countDownProgresColorValue);
      }
    }
}
</script>

<style  lang="scss">
    .progress{
        font-size: small;
        height:18px;
    }

    .menuShadow{
    -webkit-box-shadow:0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), -1px 1px 3px 0px rgb(0 0 0 / 0%) !important;
    -moz-box-shadow:0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), -1px 1px 3px 0px rgb(0 0 0 / 0%) !important;
    box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), -1px 1px 3px 0px rgb(0 0 0 / 0%) !important;
    }

    .v-progress-circular__underlay {
        stroke: var(--count-down-progress);
        stroke-opacity: 0.5;
    }


</style>